import { money } from './money';

export const INCOMING_STATUSES = ['Incoming', 'Pending Orders'];
export const PREPARATION_STATUSES = [...INCOMING_STATUSES, 'Preparing'];
export const CLOSED_STATUSES = ['Completed', 'Canceled', 'Did Not Reply', 'Did Not Get'];

export const needsPreparation = order => PREPARATION_STATUSES.includes(order?.status);
export const occupiesSchedule = order => !CLOSED_STATUSES.includes(order?.status);
export const sessionIsActive = (session, now) => !session.endedAt &&
  now - new Date(session.lastActiveAt || session.startedAt).getTime() < 60000;

export const completeOrderUpdate = order => order.status === 'Completed' ? {} : ({
  status: 'Completed', balance: 0, payment: 'Fully Paid', amountReceived: money(order.total),
  previousBalance: order.balance ?? 0, previousPayment: order.payment || 'Downpayment',
  completedAt: new Date().toISOString()
});

export const restoreOrderUpdate = order => {
  const wasCompleted = order.status === 'Completed';
  const balance = money(wasCompleted ? order.previousBalance ?? order.balance : order.balance);
  const previousPayment = (wasCompleted ? order.previousPayment : order.payment) || order.payment || 'Downpayment';
  return { status: 'Incoming', balance,
    payment: balance > 0 && previousPayment === 'Fully Paid' ? 'Downpayment' : previousPayment,
    amountReceived: money(money(order.total) - balance), previousBalance: null, previousPayment: null };
};

export const getCatalogNames = (catalog = [], legacyNames = []) => {
  const counts = {};
  return [...legacyNames, ...catalog.flatMap(bouquet => {
    const base = (bouquet.name || '').trim();
    const key = base.replace(/\s*bouquet\s*$/i, '').toLowerCase().trim();
    counts[key] = (counts[key] || 0) + 1;
    const number = bouquet.number || counts[key];
    return [base, /\d/.test(base) ? base : `${base} (${number})`];
  })];
};

export const getOrderItems = order => {
  if (Array.isArray(order?.items) && order.items.length) return order.items;
  return [{ name: order?.bouquetName || order?.item || 'Custom Bouquet', quantity: order?.quantity || 1 }];
};

export const getItemQuantity = (item, catalogNames = []) => {
  const explicit = typeof item === 'object' && item ? item.quantity ?? item.qty : null;
  if (explicit != null && Number.isInteger(Number(explicit)) && Number(explicit) > 0) return Number(explicit);
  const name = (typeof item === 'string' ? item : item?.name || '').trim();
  const isCatalog = item?.catalogId || catalogNames.some(label => label.trim().toLowerCase() === name.toLowerCase());
  if (isCatalog) return 1;
  // Preserve legacy custom quantity suffixes, but catalog variants must not become quantities.
  const match = name.match(/\((\d+)\)\s*$/);
  return match && Number(match[1]) > 0 ? Number(match[1]) : 1;
};

export const countShoppingBouquets = (orders, catalogNames = []) => {
  const counts = {};
  orders.forEach(order => getOrderItems(order).forEach(item => {
    const name = (typeof item === 'string' ? item : item?.name || 'Custom Bouquet').trim() || 'Custom Bouquet';
    counts[name] = (counts[name] || 0) + getItemQuantity(item, catalogNames);
  }));
  return counts;
};
